import { type ResponseErrorDataMessage } from './types';

export function transform400Message(message: ResponseErrorDataMessage) {
  if (typeof message === 'string') {
    return getJSONorString(message);
  }
  return message.map((item) => getJSONorString(item));
}
// NOTE MIGRATION
function getJSONorString(message: string) {
  try {
    return JSON.parse(message);
  } catch (e) {
    return message;
  }
}
